import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-loader-dialog',
  imports: [MatProgressSpinnerModule],
  templateUrl: './loader-dialog.component.html',
  styleUrl: './loader-dialog.component.scss'
})
export class LoaderDialogComponent {

}
